import { DateTime } from 'luxon';
import { z } from 'zod';

import { parseTimestamp } from '../lib/date-time.js';

export const broadbandSuppressionStatusSchema = z.enum([
  'initiated',
  'in_progress',
  'finished',
  'stopped',
  'failed',
]);

export const broadbandSuppressionModeSchema = z.enum(['solid', 'hopping', 'multi']);

const broadbandSuppressionDtoSchema = z.object({
  id: z.string(),
  deviceId: z.string(),
  type: z.enum(['analog', 'digital']),
  mode: broadbandSuppressionModeSchema.optional(),
  channelFrequencyStart: z.number().nullable(),
  channelFrequencyStop: z.number().nullable(),
  channelFrequencyList: z.array(z.number()).nullable().optional(),
  bandwidth: z.number().nullable(),
  step: z.number().nullable(),
  stepStandingTimeMs: z.number().nullable(),
  duration: z.number(),
  startedAt: z.string().nullish(),
  finishedAt: z.string().nullish(),
  isStopped: z.boolean(),
  success: z.boolean().nullish(),
  reason: z.string().nullish(),
  status: broadbandSuppressionStatusSchema,
  createdAt: z.string(),
});

export const broadbandSuppressionSchema = broadbandSuppressionDtoSchema.transform(
  (broadbandSuppression) => ({
    ...broadbandSuppression,
    startedAt: parseTimestamp(broadbandSuppression.startedAt),
    finishedAt: parseTimestamp(broadbandSuppression.finishedAt),
    createdAt: parseTimestamp(broadbandSuppression.createdAt) as DateTime,
  }),
);

export const broadbandSuppressionListSchema = z.object({
  broadbandSuppressions: z.array(broadbandSuppressionSchema),
  total: z.number(),
});

export type BroadbandSuppressionStatus = z.infer<typeof broadbandSuppressionStatusSchema>;
export type BroadbandSuppressionMode = z.infer<typeof broadbandSuppressionModeSchema>;
export type BroadbandSuppression = z.infer<typeof broadbandSuppressionSchema>;
